export const services = [
  {
    id: 1,
    title: "Otrohetskontroll",
    description: "Diskret observation och dokumentation vid misstanke om otrohet. Vi samlar bevis genom lagliga metoder och levererar en fullständig rapport.",
    features: [
      "Diskret observation",
      "Foto- och videodokumentation",
      "Detaljerad rapport",
      "Konfidentiell hantering"
    ],
    ourPrice: 1499,
    unit: "kr/uppdrag",
    icon: "search-check"
  },
  {
    id: 2,
    title: "Efterspaning av personer",
    description: "Vi hjälper dig att hitta försvunna släktingar, gamla vänner eller kontaktpersoner. Professionell spårning genom öppna källor.",
    features: [
      "Sökning i register",
      "Kontaktnätverk",
      "Social media-analys",
      "Skriftlig rapport"
    ],
    ourPrice: 1499,
    unit: "kr/uppdrag",
    icon: "users"
  },
  {
    id: 3,
    title: "Bakgrundskontroll",
    description: "Grundlig granskning av personer eller företag. Perfekt inför anställningar, affärspartners eller personliga relationer.",
    features: [
      "Registerutdrag",
      "Ekonomisk kontroll",
      "Referensverifiering",
      "Omfattande rapport"
    ],
    ourPrice: 499,
    unit: "kr/person",
    icon: "shield-check"
  },
  {
    id: 4,
    title: "Företagsutredning",
    description: "Due diligence och företagsgranskning. Vi undersöker affärspartners, konkurrenter eller misstänkta bedrägerier.",
    features: [
      "Ekonomisk analys",
      "Ägargranskning",
      "Marknadsinformation",
      "Riskbedömning"
    ],
    ourPrice: 3499,
    unit: "kr/utredning",
    icon: "eye"
  },
  {
    id: 5,
    title: "Försäkringsutredning",
    description: "Hjälper försäkringsbolag och privatpersoner med utredningar kring misstänkta försäkringsbedrägerier.",
    features: [
      "Observation och dokumentation",
      "Intervjuer",
      "Bevisinhämtning",
      "Juridisk rapport"
    ],
    ourPrice: 4499,
    unit: "kr/utredning",
    icon: "alert-triangle"
  },
  {
    id: 6,
    title: "Digitalspaning",
    description: "Undersökning av digital närvaro och aktivitet. Vi samlar information från öppna källor på internet.",
    features: [
      "Social media-analys",
      "Onlineaktivitet",
      "Digital fotavtryck",
      "OSINT-metoder"
    ],
    ourPrice: 999,
    unit: "kr/uppdrag",
    icon: "graduation-cap"
  },
  {
    id: 7,
    title: "Bevakningsuppdrag",
    description: "Diskret övervakning av person eller plats. Vi dokumenterar rörelser, möten och aktiviteter under en bestämd tidsperiod.",
    features: [
      "Diskret spaning",
      "Tidsrapportering",
      "Foto- och videomaterial",
      "Daglig uppdatering"
    ],
    ourPrice: 3499,
    unit: "kr/dag",
    icon: "eye"
  },
  {
    id: 8,
    title: "Adressverifiering",
    description: "Kontrollera om en person verkligen bor på angiven adress. Viktigt vid juridiska processer eller kreditutvärdering.",
    features: [
      "Fysisk kontroll",
      "Registerkontroll",
      "Grannintervjuer",
      "Skriftlig bekräftelse"
    ],
    ourPrice: 1499,
    unit: "kr/adress",
    icon: "shield-check"
  },
  {
    id: 9,
    title: "Bevissäkring",
    description: "Professionell dokumentation och bevakning av bevis. Säkerställer att bevis håller i juridisk process.",
    features: [
      "Rättssäker dokumentation",
      "Vittnesförhör",
      "Fotografering",
      "Juridiskt godkänd rapport"
    ],
    ourPrice: 2499,
    unit: "kr/uppdrag",
    icon: "alert-triangle"
  },
  {
    id: 10,
    title: "Stöldutredning",
    description: "Utredning av stöld, förskingring eller förlust. Vi hjälper dig att hitta försvunna tillhörigheter eller identifiera gärningsman.",
    features: [
      "Spårning av egendom",
      "Vittnesintervjuer",
      "Analys av händelseförlopp",
      "Polisanmälan support"
    ],
    ourPrice: 2999,
    unit: "kr/utredning",
    icon: "search-check"
  },
  {
    id: 11,
    title: "Alibi-verifiering",
    description: "Kontrollera om någons alibi stämmer. Vi undersöker påståenden om var en person befann sig vid en viss tidpunkt.",
    features: [
      "Tidslinjekonstruktion",
      "Vittnesintervjuer",
      "Bevisinhämtning",
      "Detaljerad analys"
    ],
    ourPrice: 2499,
    unit: "kr/uppdrag",
    icon: "users"
  },
  {
    id: 12,
    title: "Trakasserier & Stalking",
    description: "Utredning av trakasserier, stalking eller hot. Vi samlar bevis och hjälper dig att vidta rättsliga åtgärder.",
    features: [
      "Dokumentation av incidenter",
      "Identifiering av förövare",
      "Bevissäkring",
      "Juridisk vägledning"
    ],
    ourPrice: 3499,
    unit: "kr/utredning",
    icon: "shield-check"
  }
];

export const testimonials = [
  {
    id: 1,
    name: "Lisa Andersson",
    role: "Privatperson",
    text: "Professionell och diskret hjälp med min situation. Fick tydliga svar och kunde gå vidare.",
    rating: 5
  },
  {
    id: 2,
    name: "Johan Virtanen",
    role: "Företagare",
    text: "Snabb och noggrann bakgrundskontroll inför viktigt samarbete. Rekommenderas varmt!",
    rating: 5
  },
  {
    id: 3,
    name: "Emma Kovacs",
    role: "Privatperson",
    text: "Hittade min gamla vän efter många år. Otroligt tacksam för professionell hjälp!",
    rating: 5
  },
  {
    id: 4,
    name: "Marcus Lindqvist",
    role: "Företagare",
    text: "Anlitade Pignus för en företagsutredning. Grundlig och professionell rapport som gav oss trygghet i affären.",
    rating: 5
  },
  {
    id: 5,
    name: "Sofia Nguyen",
    role: "Privatperson",
    text: "Diskret och respektfull hantering av ett känsligt ärende. Fick äntligen klarhet och kunde gå vidare.",
    rating: 5
  },
  {
    id: 6,
    name: "Andreas Kowalski",
    role: "Advokat",
    text: "Använder Pignus regelbundet för klientärenden. Pålitliga och levererar alltid i tid.",
    rating: 5
  },
  {
    id: 7,
    name: "Maria Nilsson",
    role: "Privatperson",
    text: "Fantastisk service! De hittade information som polisen inte kunde hitta. Mycket professionella.",
    rating: 5
  },
  {
    id: 8,
    name: "Erik Johansson",
    role: "Säkerhetschef",
    text: "Utmärkt bakgrundskontroll av kandidater. Sparade oss från en kostsam felrekrytering.",
    rating: 5
  },
  {
    id: 9,
    name: "Anna Petrovic",
    role: "Privatperson",
    text: "Snabb respons och tydlig kommunikation hela vägen. Kände mig trygg genom hela processen.",
    rating: 5
  }
];

export const companyInfo = {
  name: "Pignus Detektivbyrå",
  tagline: "Diskreta lösningar när du behöver svar",
  description: "Vi är en professionell detektivbyrå som verkar i hela Sverige. Med över 5 års erfarenhet hjälper vi privatpersoner och företag med diskreta utredningar och informationsinsamling.",
  email: "info@pignusdetektiv.se",
  openingHours: "Måndag-Fredag: 08:00-17:00",
  emergencyNote: "För diskreta ärenden, kontakta oss via e-post så återkommer vi omgående.",
  socialMedia: {
    facebook: "https://www.facebook.com/profile.php?id=61555769303717",
    instagram: "https://www.instagram.com/pignusdetektiv/"
  }
};